import {useEffect, useState} from 'react'
import {useGlobalStore} from '../store/hooks/useStore'

const SUPPORT_PINS_PREFERENCE_ID = 'enableSupportPins'

/**
 * Reads the `enableSupportPins` custom site preference.
 * Anything other than an explicit `true` (false, null, missing, failed fetch)
 * is treated as the feature being disabled.
 */
export const useSupportPinsEnabled = () => {
  const globalStore = useGlobalStore()
  const [isSupportPinsEnabled, setIsSupportPinsEnabled] = useState<boolean>(
    globalStore.customSitePreferences[SUPPORT_PINS_PREFERENCE_ID] === true
  )
  const [isSupportPinsLoaded, setIsSupportPinsLoaded] = useState<boolean>(
    globalStore.isCustomSitePreferenceSet(SUPPORT_PINS_PREFERENCE_ID)
  )

  useEffect(() => {
    (async function () {
      if (!globalStore.isCustomSitePreferenceSet(SUPPORT_PINS_PREFERENCE_ID)) {
        await globalStore.getCustomSitePreferenceById(SUPPORT_PINS_PREFERENCE_ID)
      }
      // Read from the store after the await - customSitePreferences is replaced on update
      setIsSupportPinsEnabled(globalStore.customSitePreferences[SUPPORT_PINS_PREFERENCE_ID] === true)
      setIsSupportPinsLoaded(true)
    })()
  }, [])

  return {isSupportPinsEnabled, isSupportPinsLoaded}
}
